module.exports = __webpack_public_path__ + "img/type.22a957b6.png";